/**
 * Languages Section for Assistant Profile
 * Allows selection of languages spoken
 */
import { Card } from "@/components/ui/card";
import { LANGUAGES } from "@/lib/profileOptions";

export default function LanguagesSection({ languages, setLanguages }) {
  const toggleLanguage = (lang) => {
    if (languages.includes(lang)) {
      // Keep at least one language
      if (languages.length > 1) {
        setLanguages(languages.filter(l => l !== lang));
      }
    } else {
      setLanguages([...languages, lang]);
    }
  };

  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">Languages Spoken</h2>
      <div className="flex flex-wrap gap-2">
        {LANGUAGES.map((lang) => {
          const isSelected = languages.includes(lang);
          return (
            <button
              key={lang}
              type="button"
              onClick={() => toggleLanguage(lang)}
              className={`px-3 py-1 text-sm rounded-sm transition-all ${
                isSelected 
                  ? "bg-white text-black" 
                  : "bg-white/10 text-white/60 hover:bg-white/20"
              }`}
              data-testid={`language-${lang}`}
            >
              {lang}
            </button>
          );
        })}
      </div>
    </Card>
  );
}
